export default {
    actualDesign: [
        // {
        //   id: 1,
        //   tecnica: "SerigrafiaStm",
        //   zona: "FRONTAL",
        //   posicion: 1,
        //   design: "base64",
        //   observaciones: "",
        //   svg: "",
        //   canvasJson: ""
        // }
    ],
    bocetosRepeticion: [
        // {
        // id: identificador zona,
        // value: fichero pdf
        // }
    ],
    loadingDesign: 0,
    activeZonesId: [],

    imgInfoCanvas3d: {},
    activeZone3D: {},
    rotateDesignState: {}
}